import { useContext } from "react";
import { LeaderboardContext } from "contexts/LeaderboardContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useLeaderboardProps = () => useContext(LeaderboardContext);

export default useLeaderboardProps;
